var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HyperlinkLabel',{class:_vm.agreementsLinkClasses,attrs:{"text":_vm.text,"isAllClickable":_vm.isAllClickable},on:{"tap":function($event){return _vm.$emit('tap')}}})}
var staticRenderFns = []

export { render, staticRenderFns }